var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 2.5H12.6667C13.1239 2.5 13.5 2.87614 13.5 3.33333V12.6667C13.5 13.1239 13.1239 13.5 12.6667 13.5H3.33333C2.87614 13.5 2.5 13.1239 2.5 12.6667V3.33333C2.5 2.87614 2.87614 2.5 3.33333 2.5Z",
    stroke: "#202021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6235 6.01383L10.772 5.15625L6.79206 9.13615L5.23392 7.58405L4.37634 8.43559L6.79206 10.8453L11.6235 6.01383Z",
    fill: "#202021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOutlined);
export default __webpack_public_path__ + "static/media/checkbox_outlined.c22afb785202079efad5df88127ae7cf.svg";
export { ForwardRef as ReactComponent };